import React from 'react';
import EntityIcon, { ExternalEntityIconProps } from './EntityIcon';
import { faUserAlt } from '@fortawesome/pro-light-svg-icons';
import { getUserAvatarThumbnailUrl } from '@/services/users';
import { useCacheBuster } from '@/utils/hooks';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { User } from '@/types';

export type UserIconProps = ExternalEntityIconProps & {
    userId?: number | null | 'current';
};

const UserIcon = React.forwardRef<HTMLDivElement, UserIconProps>(
    ({ userId, emptyIcon = faUserAlt as any, sizeInPx = 50, shape = 'circle', fit = 'contain', ...rest }, ref) => {
        const user = useSelector<IState, User>((state) => state.global.user!);

        const trigger = userId === 'current' || userId === undefined ? user : userId;

        let url = useCacheBuster(userId ? getUserAvatarThumbnailUrl(userId) : '', [trigger]);

        if (!userId) {
            url = '';
        }

        return <EntityIcon ref={ref} url={url} sizeInPx={sizeInPx} emptyIcon={emptyIcon} shape={shape} fit={fit} {...rest} />;
    }
);

export default UserIcon;
